import React from "react";
import QuickMenu from "../../components/QuickMenu/QuickMenu";
import './Kvkk.scss';
const KvkkStatic = () => {
  const html = `
<h2 class="page-title">
  KVKK Başvuru Formu
  <span class="tarih">
    <i class="fa fa-calendar"></i>
  </span>
</h2>

<div class="row haber-detay-box">
  <div class="col-lg-12">
    <img src="/assets/images/KVKK.png" class="haber-detay-image">
    <div class="detay">
      <p style="text-align: center;">&nbsp;</p>
      <p style="text-align: center;"><span style="font-size: 14pt;"><strong>İSKENDERUN BELEDİYESİ</strong></span></p>
      <p style="text-align: center;"><span style="font-size: 14pt;"><strong>KİŞİSEL VERİLERİ KORUMA KANUNU BAŞVURU FORMU</strong></span></p>

      <ol>
        <li><strong>GENEL AÇIKLAMALAR</strong></li>
      </ol>

      <p>6698 Sayılı Kişisel Verilerin Korunması Kanunu’nda (KVK Kanunu) “İlgili Kişi” olarak tanımlanan kişisel veri sahiplerine “Başvuru Sahibi), KVK Kanunu’un 11. maddesinde kişisel verilerinin işlenmesine ilişkin birtakım taleplerde bulunma hakkı tanınmıştır.</p>
      <p>KVK Kanunu’nun 13. maddesinin birinci fıkrası uyarınca; bu haklara ilişkin olarak yapılacak başvuruların yazılı olarak veya Kişisel Verilerin Korunması Kurulu (Kurul) tarafından belirlenen diğer yöntemlerle Kurumumuza iletilmesi gerekmektedir.</p>
      <p>Bu çerçevede “yazılı” olarak Kurumumuza yapılacak başvurular zarf içerisinde;</p>

      <ul>
        <li>Başvuru Sahibi’nin şahsen başvurusu ile,</li>
        <li>Noter vasıtasıyla,</li>
        <li>Başvuru Sahibi tarafından 5070 Sayılı Elektronik İmza Kanununda tanımlı olan “güvenli elektronik imza” ile imzalanarak Kurumumuzun kayıtlı elektronik posta adresine (KEP) gönderilmek suretiyle tarafımıza iletilebilecektir.</li>
      </ul>

      <p>Aşağıda yazılı başvuruların ne şekilde tarafımıza ulaştırılacağına ilişkin yazılı başvuru kanalları özelinde bilgiler verilmektedir.</p>
      <p>&nbsp;</p>

      <!-- TABLO 1 -->
      <table style="border-collapse: collapse; width: 100%;" width="100%">
        <tbody>
          <tr>
            <td width="321"><p>Başvuru Yöntemi</p></td>
            <td width="225"><p>Başvurunun Yapılacağı Adres</p></td>
            <td width="388"><p>Başvuru Gönderiminde Belirtilecek Bilgi</p></td>
          </tr>
          <tr>
            <td width="321"><p>Şahsen başvuru (Başvuru sahibinin bizzat gelerek kimliğini tevsik edici belge ile başvurması)</p></td>
            <td width="225"><p>İskenderun Belediyesi</p><p>(EBYS Birimi)</p></td>
            <td width="388"><p>Zarfın üzerine</p><p>“Kişisel Verilerin Korunması Kanunu Kapsamında Bilgi Talebi” yazılacaktır.</p></td>
          </tr>
          <tr>
            <td width="321"><p>Noter vasıtasıyla tebligat</p></td>
            <td width="225"><p>İskenderun Belediyesi</p><p>(EBYS Birimi)</p></td>
            <td width="388"><p>Tebligat zarfına</p><p>“Kişisel Verilerin Korunması Kanunu Kapsamında Bilgi Talebi” yazılacaktır.</p></td>
          </tr>
          <tr>
            <td width="321"><p>“Güvenli elektronik imza” ile imzalanarak Kayıtlı Elektronik Posta (KEP) yoluyla gönderim</p></td>
            <td width="225"><p>iskenderunbelediyesi@hs01.kep.tr</p></td>
            <td width="388"><p>E-posta’nın konu kısmına</p><p>“Kişisel Verilerin Korunması Kanunu Bilgi Talebi”</p><p>yazılacaktır.</p></td>
          </tr>
        </tbody>
      </table>

      <p>&nbsp;</p>
      <p>Tarafımıza iletilmiş olan başvurularınız KVK Kanunu’nun 13. maddesinin 2. fıkrası gereğince, talebin niteliğine göre talebinizin bizlere ulaştığı tarihten itibaren otuz gün içinde yanıtlandırılacaktır. Yanıtlarımız KVK Kanunu’nun 13. maddesi hükmü gereğince yazılı veya elektronik ortamdan tarafınıza ulaştırılacaktır.</p>

      <ol>
        <li><strong>BAŞVURU SAHİBİNİN TANINMASINA VE İLETİŞİM KURULMASI İÇİN GEREKLİ BELGELER</strong></li>
      </ol>

      <p>Yapılan başvuru ile ilgili başvuru sahibini tanımlayabilmemiz ve talebinizin niteliğine göre Kurumumuz içerisinde gerekli araştırmaları yapabilmemiz için aşağıdaki bilgilerin sağlanması gerekmektedir.</p>
      <p>Bununla birlikte aşağıda belirtilen iletişim bilgileriniz, sizlerden başvurunuzla ilgili daha detaylı bilgi almak, sizleri inceleme süreçlerimiz hakkında bilgilendirmek, başvurunuzun sonuçlarını güvenli bir şekilde veri sahibine iletmek amacıyla da talep edilmektedir.</p>

      <!-- TABLO 2 (boş alan şablonları) -->
      <table style="border-collapse: collapse; width: 100%;" width="100%">
        <tbody>
          <tr><td width="208"><p>Adı Soyadı</p></td><td width="25"><p>:</p></td><td width="624"></td></tr>
          <tr><td width="208"><p>TC Kimlik Numarası</p></td><td width="25"><p>:</p></td><td width="624"></td></tr>
          <tr>
            <td rowspan="3" width="208"><p>Kurumumuzla Olan İlişkiniz</p></td>
            <td width="25"></td><td width="624"></td>
          </tr>
          <tr>
            <td width="25"><p>:</p></td>
            <td width="624"><p>Vatandaş – Yüklenici – İş Başvurusu – Diğer</p></td>
          </tr>
          <tr><td width="25"></td><td width="624"></td></tr>
          <tr><td width="208"><p>Adres</p></td><td width="25"><p>:</p></td><td width="624"></td></tr>
          <tr><td width="208"><p>Cep Telefonu</p></td><td width="25"><p>:</p></td><td width="624"></td></tr>
          <tr><td width="208"><p>E-Posta Adresi</p></td><td width="25"><p>:</p></td><td width="624"></td></tr>
          <tr><td width="208"><p>Kurumumuzla Olan İlişkiniz Sona Erdi mi?</p></td><td width="25"><p>:</p></td><td width="624"><p>Evet / Hayır</p></td></tr>
          <tr>
            <td rowspan="5" width="208"><p>Kurumumuz İçerisinde Temas Ettiğiniz Birimler</p></td>
            <td width="25"><p>:</p></td><td width="624"></td>
          </tr>
          <tr><td width="25"></td><td width="624"></td></tr>
          <tr><td width="25"></td><td width="624"></td></tr>
          <tr><td width="25"></td><td width="624"></td></tr>
          <tr><td width="25"></td><td width="624"></td></tr>
          <tr><td width="208"><p>Eski Çalışanımızsanız Çalıştığınız Yıllar</p></td><td width="25"><p>:</p></td><td width="624"></td></tr>
        </tbody>
      </table>

      <p>&nbsp;</p>
      <ol>
        <li><strong>BAŞVURU SAHİBİNİN TALEBİ</strong></li>
      </ol>

      <!-- TABLO 3 (talep hakları) -->
      <table style="border-collapse: collapse;">
        <tbody>
          <tr>
            <td><p><strong>TALEP NO</strong></p></td>
            <td colspan="3"><p><strong>TALEP KONUSU</strong></p></td>
            <td><p><strong>KANUNUN İLGİLİ MADDESİ</strong></p></td>
            <td colspan="3"><p><strong>TALEBİNİZ KONUSUNDA İSTENEN BİLGİ</strong></p></td>
            <td><p><strong>TALEBİNİZ KONUSUNDA İSTENEN BELGE</strong></p></td>
          </tr>
          <tr>
            <td><p>1</p></td>
            <td colspan="3"><p>Kişisel verimin Kurumunuzca işlenip işlenmediğini, işleniyor ise bu faaliyetlerin neler olduğu ve amacına uygun işlenip işlenmediği hakkında bilgi talep ediyorum</p></td>
            <td><p>KVKK Mad. 11/1 (a),(b),(c)</p></td>
            <td colspan="3"><p>Yok</p></td>
            <td><p>Yok</p></td>
          </tr>
          <tr>
            <td><p>2</p></td>
            <td colspan="3"><p>Kişisel Verilerim yurtiçinde ve yurtdışında üçüncü kişilere aktarılıyorsa bu üçüncü kişileri bilmek istiyorum</p></td>
            <td><p>KVKK Mad. 11/1 (ç)</p></td>
            <td colspan="3"><p>Yok</p></td>
            <td><p>Yok</p></td>
          </tr>
          <tr>
            <td><p>3</p></td>
            <td colspan="3"><p>Kişisel Verilerimin eksik veya yanlış işlendiğini düşünüyorum ve bunların düzeltilmesini istiyorum</p></td>
            <td><p>KVKK Mad. 11/1 (d)</p></td>
            <td colspan="3"><p>Eksik/yanlış olduğunu düşündüğünüz veriniz:</p></td>
            <td><p>Doğru bilgiyi gösteren belge ekleyiniz (Nüfus cüzdanı vb.)</p></td>
          </tr>
          <tr>
            <td><p>4</p></td>
            <td colspan="3"><p>Kişisel verilerimin işlenmesini gerektiren sebeplerin ortadan kalktığını düşünüyorum; verilerimin <u>Silinmesini</u> veya <u>Anonim Hale Getirilmesini</u> talep ediyorum. (Sadece birini seçiniz)</p></td>
            <td><p>KVKK Mad. 11/1 (e)</p></td>
            <td colspan="3"><p>Gerekçenizi belirtiniz</p></td>
            <td><p>Tevsik edici belgeleri ekleyiniz</p></td>
          </tr>
          <tr>
            <td><p>5</p></td>
            <td colspan="3"><p>Verilerimin münhasıran otomatik sistemler ile analiz edilmesi sonucu aleyhime sonuç doğdu; itiraz ediyorum.</p></td>
            <td><p>KVKK Mad. 11/1 (g)</p></td>
            <td colspan="3"><p>Hangi işlem/sonuç?</p></td>
            <td><p>İtiraza konu belge/kanıtları ekleyiniz</p></td>
          </tr>
          <tr>
            <td><p>6</p></td>
            <td colspan="3"><p>Kanuna aykırı işleme nedeniyle zarara uğradım; tazmin talep ediyorum.</p></td>
            <td><p>KVKK Mad. 11/1 (h)</p></td>
            <td colspan="3"><p>Aykırılık neye ilişkin?</p></td>
            <td><p>Karar, tutanak vb. ekleyiniz</p></td>
          </tr>
          <tr>
            <td><p>7</p></td>
            <td colspan="3"><p>Kanun ile ilgili farklı bir talebiniz varsa belirtiniz:</p></td>
            <td></td>
            <td colspan="3"></td>
            <td></td>
          </tr>
        </tbody>
      </table>

      <p>&nbsp;</p>
      <ol>
        <li><strong>LÜTFEN BAŞVURUNUZA VERECEĞİMİZ YANITIN TARAFINIZA BİLDİRİLME YÖNTEMİNİ SEÇİNİZ</strong></li>
      </ol>

      <ul>
        <li>Adresime gönderilmesini istiyorum.</li>
        <li>Elektronik posta KEP yolu ile gönderilmesini istiyorum.</li>
        <li>Elden teslim almak istiyorum.</li>
      </ul>

      <p>(Vekâleten teslim alınması durumunda noter tasdikli vekâletname veya yetki belgesi olması gerekmektedir.)</p>

      <p>Başvuru formu, Kurumumuz ile olan ilişkinizi tespit ederek, varsa, Kurumumuz tarafından işlenen kişisel verilerinizi eksiksiz olarak belirleyerek, ilgili başvurunuza doğru ve kanuni süresinde cevap verilebilmesi için tanzim edilmiştir. Kurumumuz, hukuka aykırı ve haksız bir şekilde veri paylaşımından kaynaklanabilecek hukuki risklerin bertaraf edilmesi ve özellikle kişisel verilerinizin güvenliğinin sağlanması amacıyla, kimlik ve yetki tespiti için ek evrak (Nüfus cüzdanı veya sürücü belgesi sureti vb.) talep etme hakkını saklı tutar. Form kapsamında iletmekte olduğunuz taleplerinize ilişkin bilgilerin doğru ve güncel olmaması ya da yetkisiz bir başvuru yapılması halinde Kurumumuz, söz konusu yanlış bilgi ya da yetkisiz başvuru kaynaklı taleplerden dolayı mesuliyet kabul etmemektedir.</p>

      <p>&nbsp;</p>
      <!-- İmza blok şablonu -->
      <table style="border-collapse: collapse;">
        <tbody>
          <tr>
            <td width="189"><p>Başvuru Sahibi Adı Soyadı</p></td><td width="19"><p>:</p></td><td width="624"></td>
          </tr>
          <tr>
            <td width="189"><p>Başvuru Tarihi</p></td><td width="19"><p>:</p></td><td width="624"></td>
          </tr>
          <tr>
            <td width="189"><p>İmza</p></td><td width="19"><p>:</p></td><td width="624"></td>
          </tr>
        </tbody>
      </table>

      <p>&nbsp;</p>
      <p><span style="font-size: 14pt;"><strong>Dosyayı indirmek için <a href="/assets/KVKK_Basvuru_Formu.docx" target="_blank" rel="noopener">tıklayınız.</a></strong></span></p>
      <p>&nbsp;</p><p>&nbsp;</p>
    </div>
  </div>
</div>
  `;

  return (
    <div className="page-container">
      <div className="page-content">
        <QuickMenu />
        <main className="main-content">
          <div className="content-wrapper">
            <div dangerouslySetInnerHTML={{ __html: html }} />
          </div>
        </main>
      </div>
    </div>
  );
};

export default KvkkStatic;
